import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import WorkEnvironmentSections from '../../../../constants/WorkEnvironmentSections';
import SvgWrapper from './components/SvgWrapper';
import Manager from './components/Quadrants/Manager';
import Team from './components/Quadrants/Team';
import Organisation from './components/Quadrants/Organisation';
import Logger from './../../../../../../logger';
import style from './style/quadrant.scss';

class Quadrant extends Component {
    getTexts(language) {
        return {
            [WorkEnvironmentSections.ORGANISATION]: <Organisation key={WorkEnvironmentSections.ORGANISATION} language={ language } classes={{ root: style.cls_6 }}/>,
            [WorkEnvironmentSections.TEAM]: <Team key={WorkEnvironmentSections.TEAM} language={ language } classes={{ root: style.cls_6 }}/>,
            [WorkEnvironmentSections.MANAGER]: <Manager key={WorkEnvironmentSections.MANAGER} language={ language } classes={{ root: style.cls_6 }}/>
        }
    }

    /**
     * getQuadrants
     * returns all 4 non-highlighted segments that make up a work environment circle
     */
    getQuadrants() {
        return [
            <path
                key={ 'n-1' }
                className={ style.cls_16 }
                d="M68.43,50.13h16a33.05,33.05,0,0,0-32-32V34.17a17,17,0,0,1,16,16"
            />,
            <path
                key={ 'n-2' }
                className={ style.cls_16 }
                d="M52.47,67.68v16a33.05,33.05,0,0,0,32-32H68.43a17,17,0,0,1-16,16"
            />,
            <path
                key={ 'n-3' }
                className={ style.cls_16 }
                d="M34.8,51.71h-16a33,33,0,0,0,32,32v-16a17,17,0,0,1-16-16"
            />,
            <path
                key={ 'n-4' }
                className={ style.cls_16 }
                d="M34.5,49.72a17,17,0,0,1,16-16v-16a33,33,0,0,0-32,32Z"
            />
        ];
    }

    /**
     * getHighlightedQuadrantForScoreLabel
     * returns a single highlighted svg segment and its position, matching the given scoreLabel
     */
    getHighlightedQuadrantForScoreLabel(scoreLabel) {
        switch (scoreLabel) {
            case 'Tasks-Freedom':
            case 'BusinessLike-Constructive':
            case 'Informal-RiskAverse':
                return {
                    position: 0,
                    svg: <path
                        key={ 'hl-1' }
                        className={ style.cls_100}
                        d="M68.73,49.71H88.38C87.84,30.63,71.85,14.64,52.77,14.1V33.75a17,17,0,0,1,16,16"
                    />
                }
            case 'Tasks-Structure':
            case 'BusinessLike-Critical':
            case 'Informal-Dynamic':
                return {
                    position: 1,
                    svg: <path
                        key={'hl-2'}
                        className={style.cls_100}
                        d="M52.47,67.75V87.4c19.08-.54,35.07-16.53,35.61-35.61H68.43a17,17,0,0,1-16,16"
                    />
                }
            case 'People-Structure':
            case 'Personal-Critical':
            case 'Hierarchical-Dynamic':
                return {
                    position: 2,
                    svg: <path
                        key={'hl-3'}
                        className={style.cls_100}
                        d="M34.5,51.93H14.85C15.4,71,31.38,87,50.47,87.54V67.89a17,17,0,0,1-16-16"
                    />
                }
            case 'People-Freedom':
            case 'Personal-Constructive':
            case 'Hierarchical-RiskAverse':
                return {
                    position: 3,
                    svg: <path
                        key={'hl-4'}
                        className={style.cls_100}
                        d="M50.47,34.17V14.52c-19.08.54-35.07,16.53-35.62,35.61H34.5a17,17,0,0,1,16-16"
                    />
                }
            default:
                Logger.instance.error({
                    component: 'report',
                    message: `could not parse score label identifier for work environment: ${scoreLabel}`
                });
                return {}
                break;
        }
    }

    /**
     * getOutput
     * constructs and returns output for a single work environment section
     */
    getOutput(scoreObj, language) {
        const quadrants = this.getQuadrants();
        const texts = this.getTexts(language);

        // replace the quadrant matching the score label with a highlighted one
        const highlight = this.getHighlightedQuadrantForScoreLabel(scoreObj.scoreLabel);

        quadrants[highlight.position] = highlight.svg;

        return <SvgWrapper
            key={scoreObj.handle}
            svgKey={`svg-${scoreObj.handle}`}
            classes={{
                root: style.cls_1,
                workEnvironmentSvgWrapper: style.work_environment_svg_wrapper,
                workEnvironmentSectionEvaluation: style.work_environment_section_evaluation
            }}
            svgPaths={quadrants}
            textPaths={texts[scoreObj.handle]}
            sectionEvaluation={ scoreObj.evaluation || '' }
        >
            <h4>{scoreObj.name}</h4>
        </SvgWrapper>
    }

    render() {
        const { score, language } = this.props;

        if (!score || !language) {
            return;
        }

        return <Fragment>
            {this.getOutput(score, language)}
        </Fragment>
    }
}
export default Quadrant;

Quadrant.propTypes = {
    score: PropTypes.object.isRequired,
    language: PropTypes.string.isRequired
};
